import { render } from "./InvoiceItemsIndex.vue?vue&type=template&id=0cf0397f"
import script from "./InvoiceItemsIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__